import { Component, OnInit, ViewChild } from '@angular/core';
import { ChatMsg, ChatService } from '../chats.service';
import { IonContent, ToastController } from '@ionic/angular';
import { marked } from 'marked';
@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.page.html',
  styleUrls: ['./chatbot.page.scss'],
})
export class ChatbotPage implements OnInit {

  @ViewChild(IonContent) content!: IonContent;
  input = '';
  sending = false;
  isTyping = false;
  messages: ChatMsg[] = [
    { role: 'assistant', content: 'Hi! I’m Mimbo 🐾 How can I help?' }
  ];
  ngOnInit(): void {

  }

  constructor(private chat: ChatService, private toast: ToastController) { }

  async send() {
    const text = this.input.trim();
    if (!text || this.sending) return;

    this.messages.push({ role: 'user', content: text });
    this.input = '';
    this.scrollBottom();
    this.sending = true;
    this.isTyping = true;

    try {
      const reply = await this.chat.askChatbot(this.messages);
      const html = (await marked.parse(reply)) as string;
      this.messages.push({ role: 'assistant', content: html });
    } catch {
      (await this.toast.create({ message: 'Failed to get reply', duration: 2000, color: 'danger' })).present();
    } finally {
      this.sending = false;
      this.isTyping = false;
      this.scrollBottom();
    }
  }


  onKeydown(e: KeyboardEvent) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      this.send();
    }
  }

  private scrollBottom() {
    setTimeout(() => this.content?.scrollToBottom(300), 50);
  }

}
